// components/chat/MessageBubble.js
import React from "react";

const MessageBubble = ({ message }) => {
	const isUser = message.sender === "user";

	return (
		<div className={`flex ${isUser ? "justify-end" : "justify-start"}`}>
			<div
				className={`max-w-[70%] p-3 rounded-lg ${
					isUser
						? "bg-blue-600 text-white rounded-br-none"
						: "bg-gray-200 dark:bg-gray-700 text-gray-900 dark:text-white rounded-bl-none"
				}`}
			>
				{message.text}
			</div>
		</div>
	);
};

export default MessageBubble;
